@if (details$ | async; as details) {
  <div class="grid grid-cols-2 gap-3">
    <app-details-view label="Zdjęcie">
      <div class="aspect-[1600/655]">
        @if (isNotNil(details.file)) {
          <app-image-thumbnail
            [rounded]="false"
            size="full">
            <img
              [alt]="details.file.alt"
              [fill]="true"
              [ngSrc]="details.file.url!"
              class="object-contain"
              loading="lazy" />
          </app-image-thumbnail>
        } @else {
          <app-image-thumbnail-unsupported
            [rounded]="false"
            size="full" />
        }
      </div>
    </app-details-view>

    <app-details-view label="Zdjęcie dla wersji mobilnej">
      <div class="aspect-[1600/655]">
        @if (isNotNil(details.smallFile)) {
          <app-image-thumbnail
            [rounded]="false"
            size="full">
            <img
              [alt]="details.smallFile.alt"
              [fill]="true"
              [ngSrc]="details.smallFile.url!"
              class="object-contain"
              loading="lazy" />
          </app-image-thumbnail>
        } @else {
          <app-image-thumbnail-unsupported
            [rounded]="false"
            size="full" />
        }
      </div>
    </app-details-view>
  </div>

  <div class="mt-4 grid grid-cols-2 gap-3">
    <app-details-view label="Identyfikator">
      {{ details.id }}
    </app-details-view>

    <app-details-view label="Lokalizacja">
      {{ details.location | bannerLocationType | async }}
    </app-details-view>

    <app-details-view label="Adres URL">
      @if (details.url) {
        <app-external-link [link]="details.url">
          <span>{{ details.url }}</span>
        </app-external-link>
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Status">
      {{ details.status | adminBannerStatus | async }}
    </app-details-view>

    <app-details-view label="Data rozpoczęcia wyświetlania">
      @if (details.visibilityStartDate) {
        <app-date-time [date]="details.visibilityStartDate" />
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Data zakończenia wyświetlania">
      @if (details.visibilityEndDate) {
        <app-date-time [date]="details.visibilityEndDate" />
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Liczba przekierowań">
      {{ details.redirects }}
    </app-details-view>
  </div>
} @else {
  <app-spinner-filled />
}
